import * as visit from "@/api/listPaid";

const state = {
  selectNakes: []
};

const mutations = {
  SET_selectNakes: (state, value) => {
    state.selectNakes = value;
  }
};
const actions = {
  list({ commit }, dataParams) {
    return new Promise((resolve, reject) => {
      visit
        .listPaid(dataParams)
        .then(response => {
          resolve(response);
          console.log(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
export default {
  namespaced: true,
  actions,
  mutations,
  state
};



// WEBPACK FOOTER //
// ./src/store/modules/listPaid.js